<section class="storyblok-blok-container">
  <div *ngIf="products?.length >= NUMBER_6" class="advanced-carousel advanced-carousel__banner-plus-carousel" [ngClass]="computedClasses">
    <div class="banner">
      <div class="banner__container">
        <div class="banner__container__info-section">
          <header [ngClass]="{ 'promo-header': isPromo }">
            <h2 class="carousel-sub-header" *ngIf="subHeading && !isPromo">
              {{ subHeading }}
            </h2>
            <mm-icon name="promo-icon" class="advanced-promo-icon" *ngIf="isPromo"></mm-icon>
            <h1 class="carousel-title"
              [ngClass]="{
                'font-small':
                  ((subHeading || isPromo) && description && button?.length) ||
                  ((!subHeading || !isPromo) && description && button?.length),
                'title-promo': isPromo
              }"
            >
              {{ title }}
            </h1>
            <p class="carousel-description" *ngIf="description && !isMobile">
              {{ description }}
            </p>
          </header>
          <div *ngIf="!isMobile && button?.length > 0" class="button-container">
            <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: button }"></ng-container>
          </div>
        </div>
      </div>
      <div
        [title]="image?.title"
        [attr.aria-label]="image?.alt"
        class="banner__image-section"
        [style.background-image]="'url(' + (image?.filename + sbFormatParam) + ')'"
      ></div>
    </div>

    <div class="banner-carousel-container">
      <app-product-advanced-carousel
        class="carousel carousel-background"
        [hasEndPadding]="hasEndPadding"
        [isMobile]="isMobile"
        [isDesktop]="!isMobile"
        [products]="products"
        [title]="title"
        [trackingName]="trackingName"
        (productClicked)="onProductClickEvent($event.product, $event.priceType, $event.index)"
        (productCarouselPrev)="onProductCarouselNavigation(DIRECTION.LEFT)"
        (productCarouselNext)="onProductCarouselNavigation(DIRECTION.RIGHT)"
        (swipeLeft)="onProductCarouselSwipe(DIRECTION.LEFT)"
        (swipeRight)="onProductCarouselSwipe(DIRECTION.RIGHT)"
      >
      </app-product-advanced-carousel>
      <div *ngIf="isMobile && button?.length > 0" class="button-container">
        <ng-container *ngTemplateOutlet="buttonTemplate; context: { button: button }"></ng-container>
      </div>
    </div>
  </div>
</section>

<ng-template #buttonTemplate let-button="button">
  <button type="button" (click)="onButtonClickAction()">
    {{ button[0]?.text || 'CATALOG.DETAILS_PAGE.SERIES_CAROUSEL.SEE_ALL' | translate }}
    <mm-icon name="arrow-right"></mm-icon>
  </button>
</ng-template>
